module.exports = __webpack_public_path__ + "img/ticket-one.9cdc7d49.svg";